"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_THEME_CONFIG = exports.transperentizeColor = void 0;
var tslib_1 = require("tslib");
var transperentizeColor_1 = (0, tslib_1.__importDefault)(require("./utils/transperentizeColor"));
exports.transperentizeColor = transperentizeColor_1.default;
var theme_service_1 = (0, tslib_1.__importStar)(require("./theme-service"));
Object.defineProperty(exports, "DEFAULT_THEME_CONFIG", { enumerable: true, get: function () { return theme_service_1.DEFAULT_THEME_CONFIG; } });
exports.default = theme_service_1.default;
//# sourceMappingURL=index.js.map